import { render } from "./AddQna.vue?vue&type=template&id=73cc67b5&scoped=true"
import script from "./AddQna.vue?vue&type=script&lang=js"
export * from "./AddQna.vue?vue&type=script&lang=js"

import "./AddQna.vue?vue&type=style&index=0&id=73cc67b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cc67b5"]])

export default __exports__